import React from "react";
import LoaderTemplate from "../../component/LoaderTemplate";
import { HistoryAndCommentLoader } from "../../component/LoadersTemplate";
import IssueActivityHistory from "../issueDetail/IssueActivityHistory";
import { isValidArray } from "../../helper";
import { STATUS } from "../../constant";
import { Image } from "react-bootstrap";

export default ({ isLoading, data, template, getAllComments, MarginTop }) => {
  const dataToIterate = data
    ? isValidArray(data.filter(value => isValidArray(value)))
    : [];
  return (
    <div className="history-activity-content">
      {isLoading === STATUS.LOADING ? (
        <LoaderTemplate
          height={80}
          width={300}
          children={<HistoryAndCommentLoader />}
        />
      ) : (
        (isValidArray(dataToIterate) ? (
          dataToIterate.map(value =>
            isValidArray(value) ? (
              <div className="issue-comments-section">
                <div className="issue-commnets-header">
                  {value[0] ? (
                    <>
                      {template ? (
                        template(value)
                      ) : (
                        <h4>
                          {value[0].isIssueDuplicate
                            ? "Duplicate Issue"
                            : "Issue"}{" "}
                          <span className="issue-id">#{value[0].issueId}</span>
                        </h4>
                      )}
                    </>
                  ) : null}
                </div>
                {value.map(comment => (
                  <div key={value.date}>
                    <IssueActivityHistory
                      history={comment}
                      pendingComments={comment.status == "PENDING"}
                      approvedBy={comment.approvedBy}
                      modifiedBy={comment.modifiedDate}
                      getAllComments={getAllComments}
                      buttonVisibility={true}
                      MarginTop={MarginTop}
                    />
                  </div>
                ))}
                <span className="shadow" />
              </div>
            ) : null
          )
        ) : (
          <Image
            src="https://pmiic-local-files.s3.ap-south-1.amazonaws.com/no_comments.png"
            alt="No comments"
            className="no-comments-image"
          />
        )) || null
      )}
    </div>
  );
};
